import { Link } from "react-router-dom"
import ThemeModal from "components/Common/ThemeModal"
import { useDailySummaryEmployees } from "hooks/attendanceHook"
import { formatReadableTimeInZone } from "utils/formatDate"

const STATUS_LABELS = { present: "On time", late: "Late" }

const AttendanceSummaryModal = ({ isOpen, toggle, filter, label, date, timeZone }) => {
  const { data, isLoading, isError } = useDailySummaryEmployees(
    { date, filter },
    isOpen && !!filter
  )

  const employees = data?.data ?? []

  return (
    <ThemeModal
      isOpen={isOpen}
      toggle={toggle}
      title={label ? `${label} — ${date ?? ""}` : ""}
      size="lg"
      backdrop={true}
      keyboard={true}
    >
      <div className="table-responsive">
        <table className="table table-sm table-hover align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Employee ID</th>
              <th>Check In</th>
              <th>Check Out</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && (
              <tr>
                <td colSpan={6} className="text-center py-4 text-muted">
                  Loading…
                </td>
              </tr>
            )}
            {isError && (
              <tr>
                <td colSpan={6} className="text-center py-4 text-danger">
                  Failed to load employees.
                </td>
              </tr>
            )}
            {!isLoading && !isError && employees.length === 0 && (
              <tr>
                <td colSpan={6} className="text-center py-4 text-muted">
                  No employees found.
                </td>
              </tr>
            )}
            {!isLoading &&
              !isError &&
              employees.map((emp, idx) => (
                <tr key={emp.id ?? idx}>
                  <td className="text-muted">{idx + 1}</td>
                  <td>
                    {emp.id ? (
                      <Link
                        to={`/employee-list/${emp.id}/view`}
                        className="fw-semibold text-primary"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {emp.name ?? "—"}
                      </Link>
                    ) : (
                      <span className="fw-semibold">{emp.name ?? "—"}</span>
                    )}
                  </td>
                  <td className="text-muted">{emp.employee_code ?? "—"}</td>
                  <td>{formatReadableTimeInZone(emp.check_in_at, timeZone)}</td>
                  <td>{formatReadableTimeInZone(emp.check_out_at, timeZone)}</td>
                  <td>
                    {emp.status ? (
                      <span
                        className={`badge bg-${emp.status === "late" ? "danger" : "success"}`}
                      >
                        {STATUS_LABELS[emp.status] ?? emp.status}
                      </span>
                    ) : (
                      "—"
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </ThemeModal>
  )
}

export default AttendanceSummaryModal
